import Link from 'next/link'
import { useD9 } from '../../../hooks/use-d9-data'
import { useTranslations } from 'next-intl'
import PdImage from '../../../components/pd-image/pd-image'
import { useMemo } from 'react'
import { useChinaDetector } from '../../../common/region-locale'

export function Section6() {
  const { section6 } = useD9()
  const t = useTranslations()
  const inChina = useChinaDetector()
  const d9NewsUrl = inChina ? '/news/828' : '/news/1016'

  return (
    <section className="w-full bg-black laptop:py-30 py-15 laptop:px-0 px-4">
      <div className="w-300 max-w-full mx-auto">
        <div className="header w-full flex flex-col laptop:gap-6 gap-3 items-center">
          <h2 className="text-white/90 laptop:text-5xl text-2xl font-semibold">{section6.title}</h2>
          <h3 className="text-white/90 text-base laptop:text-lg font-normal">{section6.subTitle}</h3>
          <Link href={d9NewsUrl}>
            <div className="px-4 py-2 bg-[#f2f3f5] rounded-[19px] justify-center items-center gap-1 inline-flex cursor-pointer">
              <span className="text-black/90 text-sm font-normal">{t('KnowMore')}</span>
            </div>
          </Link>
        </div>
      </div>

      {/* 3 images */}
      <div className="w-full grid laptop:grid-cols-3 grid-colos-1 laptop:gap-6 gap-3 mt-8 laptop:mt-16">
        {section6.images.map((image, index) => (
          <div key={index} className="relative laptop:h-[18.8vw] h-395px">
            <PdImage alt="image" src={image} width="100%" height="100%" useLoader />
          </div>
        ))}
      </div>
    </section>
  )
}
